<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'
import ABaseInput from '~/components/atoms/forms/BaseInput.vue'
import { InputType } from '~/static/enums/components/base-input'

interface Props {
  name: string
  error: string
}

defineProps<Props>()
const emit = defineEmits<{
  (e: 'change-name', value: string): void
  (e: 'save'): void
  (e: 'cancel'): void
}>()

const changeName = (value: string) => {
  emit('change-name', value)
}
const save = () => {
  emit('save')
}
const cancel = () => {
  emit('cancel')
}

const refModal: Ref = ref(null)
const closeModal = () => {
  if (refModal.value !== null) {
    refModal.value.closeModal()
  }
}
defineExpose({
  closeModal,
})

</script>

<template>
  <RModal
    ref="refModal"
    name-modal="nameChangeModal"
    @close="cancel"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="nameChangeModalLabel"
      >
        Изменение названия
      </h5>
    </template>

    <template #body>
      <div class="body">
        <span class="d-block mb-2 form-label">Название</span>
        <ABaseInput
          placeholder="Без названия"
          class="mb-lg-5"
          :value="name"
          :type="InputType.Text"
          :error-message="error"
          @change="changeName"
          @input="changeName"
          @enter="save"
        />
      </div>
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Secondary"
        @click="closeModal"
      >
        Закрыть
      </AButton>
      <AButton
        :button-style="ButtonStyle.Primary"
        @click="save"
      >
        Переименовать
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  width: 100%;
}
</style>
